module.exports = {"id":"dp3_4l1q3","text":"Computational Thinking and Programming","instructions":"Which of the following is an example of an AI system?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l1q3-a1","text":"A system that recommends content using data","score":1.8},{"id":"dp3_4l1q3-a2","text":"A calculator performing fixed operations","score":0},{"id":"dp3_4l1q3-a3","text":"A document stored on a computer","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l1q3.json
// module id = 1177
// module chunks = 41